/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestOldSubmissionAgeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_OLD_SUBMISSION_AGE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
]);
export class NewAutoTestOldSubmissionAgeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestOldSubmissionAgeSettingParser.decode(input).map(res => new NewAutoTestOldSubmissionAgeSetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestOldSubmissionAgeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestOldSubmissionAgeSettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestOldSubmissionAgeSettingParser.schema();
    }
}
